import { createContext, useCallback, useContext, type AnchorHTMLAttributes, type ComponentType, type ReactNode } from "react";

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };
export type LinkComponent = ComponentType<LinkProps>;
type RenderLink = (props: LinkProps) => ReactNode;

const renderNativeLink: RenderLink = ({ children, ...rest }) => <a {...rest}>{children}</a>;

const LinkContext = createContext<RenderLink>(renderNativeLink);

/** Lets router-agnostic shell components render the app's router link (e.g. React Router). */
export function LinkProvider({ component: Component, children }: { component: LinkComponent; children: ReactNode }) {
  const render = useCallback<RenderLink>((props) => <Component {...props} />, [Component]);
  return <LinkContext.Provider value={render}>{children}</LinkContext.Provider>;
}

export function AppLink(props: LinkProps) {
  const render = useContext(LinkContext);
  return render(props);
}
